import React from "react";
import VideoAndAssistance from "./VideoAndAssistance";

const Soccer4Rules = () => {
  return (
    <div>
      <VideoAndAssistance videoId="zavxhvPI_VU" />
      <p>Soccer 4, from the same stable as Soccer 6, tests your knowledge of soccer to the limit.</p>
      <p>
        Soccer 4 is just like Soccer 6, but with two big differences – only 4 matches (not 6) and 6 options to choose from per match (not 3). Soccer 4 is a real
        test of soccer fans’ football knowledge.
      </p>
      <p>
        <strong>PLEASE NOTE: </strong>In Soccer 4 and other TAB soccer bets, the result of a match is the score at the end of the normal 90-minute playing
        period plus any injury time that may be played. Extra time and penalty shootouts are of no account.
      </p>
      <h2>Easy to Play, Tough to Win</h2>
      <p>
        This is how Soccer 4 works: To win, you must predict the results of the four matches in the Soccer 4 pool. In each match, one team is designated Team A
        and the other Team B. There are six results to choose from in each of the four matches (M1, M2, M3, M4):
      </p>
      <ul>
        <li>Team A win by difference of only 1 goal (1-0; 3-2; 4-3; 5-4; 6-5 etc)</li>
        <li>Team A win by difference of 2 goals of more (2-0; 3-1; 4-1; 5-0; 6-3 etc)</li>
        <li>No-score draw (0-0 only)</li>
        <li>Score draw (1-1; 2-2; 3-3; 4-4 etc)</li>
        <li>Team B win by difference of only 1 goal</li>
        <li>Team B win by difference of 2 goals or more</li>
      </ul>
      <p>The computerised tote betting system uses numbers to denote the above options:</p>
      <div className="panel">
        1 = Win by Team A by one goal; 2 = Win by Team A by two goals or more; 3 = No-score draw; 4 = Score draw; 5 = Win by Team B by one; 6 = Win by Team B by
        two or more. So when you bet, use Nos 1 - 6 to denote your choices. The same numbers are used to display results. M1 is used to denote Match 1, M2 for
        Match 2 and so on.
      </div>
      <h2>What does Soccer 4 Cost?</h2>
      <p>
        The cost of the bet and all the other rules are the same as Soccer 6. A single entry (one choice per match) costs R6 and the cost of a multiple entry is
        R6 per combination.
      </p>
      <p>
        The cost of a multiple or permutation entry is calculated in the same way as Soccer 6. Simply total the number of choices you have made in each of the
        four matches and multiply them out. Then multiply that total by six to get the total cost in rands.
      </p>
      <p>
        <strong>EXAMPLES:</strong>
      </p>
      <div className="panel">You choose 2 options per match. That’s 2 x 2 x 2 x 2 = 16 x 6 = R96.</div>
      <div className="panel">You choose 3 options in M1; 2 options in M2; 4 options in M3 and 1 in M4. That’s 3 x 2 x 4 x 1 = 24 x 6 = R144.</div>
      <h2>Key Soccer 4 Information</h2>
      <ul>
        <li>
          On the Soccer 4 bet slip, mark the S4 oval and then the P1 or P2 or P3 oval (which oval to mark is shown when matches for each pool are displayed)
        </li>
        <li>
          In Soccer 4, The result of a match shall be the score at the end of the normal 90-minute playing period plus any injury time that may be played. It
          shall not include extra time nor penalty shootouts.
        </li>
        <li>
          Any match in a Soccer 6, 4 or 10 pool not completed by 9am on the day after the last day on which matches in the pool were scheduled, shall be deemed
          abandoned and all choices shall qualify. The times at which matches are completed will be as supplied by the operator's official source,
          notwithstanding the operator's decision in terms of when a match has not been completed shall be final and binding. Further, the operator reserves the
          right to extend the time for a match to be completed if circumstances warrant and provided this does not unduly hamper the declaration of results and
          dividends.
        </li>
        <li>The number of winning entries determines the payout.</li>
        <li>Official Soccer 4 payouts are declared as soon as official results of the matches are received.</li>
        <li>Results and payouts are published on this website and displayed at TABs as soon as they become available.</li>
        <li>
          If you have a winning combination, present your ticket and collect your money at any TAB outlet. For telephone betting and online account holders,
          winnings are automatically credited to your account and can be transferred directly into your bank account.
        </li>
        <li>Soccer 4 is a product of Phumelela-Gold Enterprises.</li>
      </ul>
    </div>
  );
};

export default Soccer4Rules;
